import { render, staticRenderFns } from "./VideoPartial.vue?vue&type=template&id=5dd948dc&scoped=true&"
import script from "./VideoPartial.vue?vue&type=script&lang=js&"
export * from "./VideoPartial.vue?vue&type=script&lang=js&"
import style0 from "./VideoPartial.vue?vue&type=style&index=0&id=5dd948dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd948dc",
  null
  
)

export default component.exports